module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "mike",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_c('h1', {
    staticClass: "sigilnotintoc"
  }, [_vm._v("MIKE")]), _vm._v(" "), _c('h1', {
    staticClass: "sigilnotintoc"
  }, [_vm._v("A PUBLIC SCHOOL STORY")]), _vm._v(" "), _c('h1', {
    staticClass: "sigilnotintoc"
  }, [_vm._v("BY")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('h2', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("P. G. WODEHOUSE")]), _vm._v(" "), _c('h4', {
    staticClass: "sigilnotintoc2",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("AUTHOR OF \"THE GOLD BAT,\" \"A PREFECT'S UNCLE,\" ETC.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61359558","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0001_split_000.vue
// module id = 57
// module chunks = 0